import { render, staticRenderFns } from "./DfApp.vue?vue&type=template&id=08fc2fd0&"
import script from "./DfApp.vue?vue&type=script&lang=js&"
export * from "./DfApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports